export const GET_PROJECT_PERIODS = 'GET_PROJECTS_PERIODS';

export function getProjectPeriod(periods) {
  return {
    type: GET_PROJECT_PERIODS,
    data: periods,
  };
}
